import React from "react"
import styled from "styled-components"
import { socialMedia } from "../config.js"
import Side from "./side.js"
import { Icon } from "../components/icons"

const StyledSocialList = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;

  @media (max-width: 900px) {
    display: none;
  }

  &:after {
    content: "";
    display: block;
    width: 1px;
    height: 90px;
    margin: 0 auto;
    background-color: black;
    opacity: 0.25;
  }

  li {
    margin-bottom: 10px;
    &:last-of-type {
      margin-bottom: 20px;
    }

    a {
      padding: 10px;

      svg {
        width: 20px;
        height: 20px;
      }
      opacity: 0.65;
      &:hover,
      &:focus {
        opacity: 1;
      }
    }
  }
`

const Social = () => (
  <Side orientation="left" top="bottom">
    <StyledSocialList>
      {socialMedia &&
        socialMedia.map(({ url, name }, i) => (
          <li key={i}>
            <a href={url} aria-label={name}>
              <Icon name={name} />
            </a>
          </li>
        ))}
    </StyledSocialList>
  </Side>
)

export default Social
